var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegistration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(-326.52 -290.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M372.469,333.75,362.9,330.88a2.92,2.92,0,0,1-2.072-2.807v-3.06a15.573,15.573,0,0,0,6.276-12.492v-1.677c.034,0,.07,0,.1,0a1.464,1.464,0,0,0,1.464-1.464V298.4a1.463,1.463,0,0,0-1.7-1.443,7.764,7.764,0,0,0-7.606-6.3h-15.69a7.772,7.772,0,0,0-7.6,6.276h-.243a1.465,1.465,0,0,0-1.465,1.465v10.983a1.463,1.463,0,0,0,1.465,1.464c.034,0,.069,0,.1,0v1.677a15.573,15.573,0,0,0,6.276,12.492v3.06a2.921,2.921,0,0,1-2.094,2.815l-9.546,2.863a5.648,5.648,0,0,0-4.05,5.442,1.465,1.465,0,1,0,2.93,0,2.736,2.736,0,0,1,1.961-2.636l7.773-2.332a7.761,7.761,0,0,0,7.629,6.433h9.414a7.741,7.741,0,0,0,7.629-6.433l7.772,2.332a2.735,2.735,0,0,1,1.963,2.636,1.465,1.465,0,1,0,2.93,0,5.647,5.647,0,0,0-4.051-5.442m-6.725-33.287v6.853l-9.791-3.426Zm-22.07-6.876h15.69a4.807,4.807,0,0,1,4.585,3.346h-24.86a4.816,4.816,0,0,1,4.585-3.346m-6.38,6.276h21.3l-21.3,7.453Zm1.569,12.656v-2.648l12.656-4.43,12.655,4.43v2.648a12.656,12.656,0,1,1-25.312,0m17.363,25.208h-9.414a4.809,4.809,0,0,1-4.8-4.466,5.827,5.827,0,0,0,3.126-5.19v-1.333a15.578,15.578,0,0,0,12.761,0v1.333a5.825,5.825,0,0,0,3.125,5.19,4.81,4.81,0,0,1-4.8,4.466",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M354.108,309.7a1.617,1.617,0,1,1-1.617,1.616,1.617,1.617,0,0,1,1.617-1.616",
    transform: "translate(-2.589 -1.899)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistration);
export default __webpack_public_path__ + "static/media/registration.0f98347fb7faa53d98bd74add854e4b5.svg";
export { ForwardRef as ReactComponent };